import { Box, VStack, T } from '@minetrace/ui'
import { useFormColors } from '@minetrace/ui/forms'
import { LuMountain as Mountain } from 'react-icons/lu'
import MiningRightCard from '../../../components/MiningRightCard'
import type { MiningRightResponse, MiningRightComponentResponseItem } from '../../../api/models/response/proveedor'

interface Step3MiningRightsProps {
  mode: 'edit' | 'readonly'
  companyId?: string | null
  savedMiningRights: MiningRightResponse[]
  onSavePolygon: (mrId: string, vertices: { northing: number; easting: number }[], utmZone: number) => Promise<void>
  onAddComponent: (mrId: string, data: { componentTypeId: string; name?: string; northing: number; easting: number }) => Promise<MiningRightComponentResponseItem>
  onRemoveComponent: (mrId: string, componentId: string) => Promise<void>
  onRefresh: () => Promise<void>
}

export default function Step3MiningRights({
  companyId,
  savedMiningRights,
  onSavePolygon,
  onAddComponent,
  onRemoveComponent,
  onRefresh,
}: Step3MiningRightsProps) {
  const c = useFormColors()

  return (
    <VStack gap={6} alignItems="stretch">
      {savedMiningRights.length === 0 ? (
        <Box
          p={8}
          textAlign="center"
          borderRadius="xl"
          border="1px dashed"
          borderColor="gray.200"
        >
          <Mountain size={32} style={{ margin: '0 auto 12px', opacity: 0.3 }} />
          <T tid="proveedores.wizard.step3.emptyMessage" fontSize="sm" color={c.textMuted} />
        </Box>
      ) : (
        <VStack gap={5} alignItems="stretch">
          {savedMiningRights.map((right) => (
            <MiningRightCard
              key={right.id}
              right={right}
              companyId={companyId}
              onUpdated={onRefresh}
              onSavePolygon={onSavePolygon}
              onAddComponent={onAddComponent}
              onRemoveComponent={onRemoveComponent}
              components={right.components ?? []}
            />
          ))}
        </VStack>
      )}
    </VStack>
  )
}
